import React from 'react';
import { CTASection } from '../../../components/CTASection';
export function CTA() {
  return <section className="py-16 bg-white" data-id="element-476">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-477">
        <CTASection headline="Have an Embedded Systems Project?" body="Let's discuss your hardware and industrial software requirements with our engineering team." buttonText="Start the Conversation" buttonLink="/contact" variant="dark" data-id="element-478" />
      </div>
    </section>;
}